import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/especialidad-de-estudios';

/**
 * GET Especialidad de estudio
 * @returns {Promise<object[]>}
 */
export const getEspecialidadesDeEstudios = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Especialidad de estudio
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getEspecialidadDeEstudio = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Especialidad de estudio
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEspecialidadDeEstudio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Especialidad de estudio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEspecialidadDeEstudio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Especialidad de estudio
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteEspecialidadDeEstudio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
